import { render, staticRenderFns } from "./esgPage.vue?vue&type=template&id=8394c5de&scoped=true"
import script from "./esgPage.vue?vue&type=script&lang=js"
export * from "./esgPage.vue?vue&type=script&lang=js"
import style0 from "./esgPage.vue?vue&type=style&index=0&id=8394c5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8394c5de",
  null
  
)

export default component.exports